export enum LearnMoreLinks {
  PICK_AND_PACK = '/hc/en-us/articles/21186588490258-How-to-use-Easyship-s-Pick-and-Pack-feature',
}
